import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_595_3598)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.5 1.5H15.5C15.5 1.5 16.5 1.5 16.5 2.5V15.5C16.5 15.5 16.5 16.5 15.5 16.5H2.5C2.5 16.5 1.5 16.5 1.5 15.5V2.5C1.5 2.5 1.5 1.5 2.5 1.5Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.17647",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.82533 11.44C7.73833 11.4833 7.64169 11.5038 7.54457 11.4993C7.44745 11.4949 7.35307 11.4657 7.2704 11.4146C7.18773 11.3634 7.11949 11.292 7.07217 11.2071C7.02485 11.1221 7.00001 11.0265 7 10.9293V7.07064C7.00001 6.97342 7.02485 6.87781 7.07217 6.79288C7.11949 6.70796 7.18773 6.63653 7.2704 6.58538C7.35307 6.53422 7.44745 6.50504 7.54457 6.5006C7.64169 6.49615 7.73833 6.51658 7.82533 6.55997L11.6847 8.49C11.7795 8.53726 11.8591 8.61006 11.9149 8.70013C11.9706 8.7902 12.0001 8.89406 12.0001 9C12.0001 9.10586 11.9706 9.20973 11.9149 9.2998C11.8591 9.38986 11.7795 9.46266 11.6847 9.51L7.82533 11.44Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.17647",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.5 4H16.5",
                        stroke: color || "#676879",
                        strokeWidth: "1.17647",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.5 14H16.5",
                        stroke: color || "#676879",
                        strokeWidth: "1.17647",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_595_3598",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(1 1)"
                    })
                })
            })
        ]
    });
